import { ADD_MS_TEAMS_CONTEXT } from './actionTypes';

export function addMSTeamsContext(context) {
  return {
    type: ADD_MS_TEAMS_CONTEXT,
    data: context,
  };
}
